import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { apiGetSetting } from '../services/api.service.js';

/**
 * Layout Component - Component layout chung cho toàn bộ ứng dụng
 * 
 * Component này cung cấp:
 * - Background chính cho tất cả các trang
 * - Các ảnh decor (left, right, logo)
 * - Nút back để quay lại trang trước
 * - Responsive design cho mobile và desktop
 * 
 * @param {React.ReactNode} children - Nội dung của các page được render bên trong layout
 */
function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  /**
   * Xử lý sự kiện click nút back
   * Quay lại màn hình trước, hoặc về link_home khi hết lịch sử trong ứng dụng
   */
  const handleBackClick = async () => {
    if (window.history.state?.idx > 0) {
      navigate(-1);
      return;
    }

    let webSetting = location.state?.webSetting;
    if (!webSetting?.link_home) {
      const result = await apiGetSetting();
      if (result?.status_code !== 200) return;
      webSetting = result.data;
    }

    if (webSetting?.link_home) {
      window.location.href = webSetting.link_home;
    } else {
      Swal.fire({ icon: 'error', text: 'Chưa cấu hình đường dẫn trang chủ, vui lòng liên hệ CSKH.' });
    }
  };

  return (
    <>
      {/* Background layer cố định */}
      <div
        className="fixed inset-0 -z-10"
        style={{
          backgroundImage: "url('/bg/bg.png')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          width: "100%",
          height: "100%"
        }}
      />



      {/* Container chính với nội dung */}
      <div className="relative min-h-screen w-full flex flex-col justify-start items-center">
        {/* Ảnh decor bên trái - hiển thị ở góc dưới bên trái */}
        {/* Responsive: lg:250px, md:200px, mobile:150px */}
        <img
          src='/bg/left.png'
          className='fixed left-0 bottom-1 lg:w-[250px] md:w-[200px] w-[150px] h-auto object-contain z-0'
          alt="background left"
        />

        {/* Ảnh decor bên phải - hiển thị ở góc dưới bên phải */}
        {/* Responsive: lg:250px, md:200px, mobile:150px */}
        <img
          src='/bg/right.png'
          className='fixed right-0 bottom-1 lg:w-[250px] md:w-[200px] w-[150px] h-auto object-contain z-0'
          alt="background right"
        />

        {/* Nút back - hiển thị ở góc trên bên trái */}
        {/* z-10: đảm bảo nút luôn ở trên các ảnh decor */}
        <button onClick={handleBackClick} className="absolute left-0 top-1 z-11 cursor-pointer">
          {/* Ảnh nút back cho desktop/tablet - ẩn trên mobile (md:hidden) */}
          <img
            src='/bg/back.png'
            className='lg:w-[150px] w-[130px] h-auto object-contain md:block hidden pointer-events-none'
            alt="back button desktop"
          />
          {/* Ảnh nút back cho mobile - chỉ hiển thị trên mobile (md:hidden block) */}
          <img
            src='/bg/backmb.png'
            className='sm:w-[60px] w-[50px] h-auto object-contain md:hidden block pointer-events-none'
            alt="back button mobile"
          />
        </button>

        {/* Container cho nội dung chính của các page */}
        {/* z-10: đảm bảo nội dung luôn ở trên các ảnh background */}
        <div className="relative z-10 w-full max-w-[640px] max-[640px]:max-w-[480px] max-[480px]:max-w-[360px] md:px-5 px-2 mx-auto mb-10">
          {/* Logo chính - căn giữa ở phía trên */}
          {/* left-1/2 -translate-x-1/2: căn giữa theo chiều ngang */}
          {/* Responsive: lg:300px, md:250px, mobile:200px */}
          <img
            src='/bg/logo.png'
            className='lg:w-[300px] md:w-[250px] w-[200px] h-auto object-contain pt-5 md:pt-8 mx-auto mb-5'
            alt="logo"
          />
          {children}
        </div>
      </div>
    </>
  );
}

export default Layout;

